// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","tos-modal__alert":"tos-modal_tos-modal__alert__wXfn7","tos-modal__link":"tos-modal_tos-modal__link__5FVgn"};